<a (click)="goToPage(data?.id)"> {{ data?.label }} </a>
